export const getIconStyles = () => ({
  '& .recommendation-keyword-icon': {
    backgroundColor: '#00AD56',
  },
  '& .recommendation-repair-icon': {
    backgroundColor: '#A80000',
  },
  '& .recommendation-ads-icon': {
    backgroundColor: '#0078D4',
  },
  '& .recommendation-bid-icon': {
    backgroundColor: '#00B7C3',
  },
  '& .recommendation-shopping-cart-icon': {
    backgroundColor: '#CA5010',
  },
  '& .recommendation-extension-icon': {
    backgroundColor: '#4F6BED',
  },
  '& .recommendation-seasonal-icon': {
    backgroundColor: '#E3008C',
  },
  '& .recommendation-targeting-icon': {
    backgroundColor: '#881798',
  },
  '& .recommendation-budget-icon': {
    backgroundColor: '#8378DE',
  },
  '& .recommendation-auto-apply-icon': {
    backgroundColor: '#373277',
  },
  '& .recommendation-p-max-icon': {
    backgroundColor: '#038387',
  },
  '& .recommendation-syndication-icon': {
    backgroundColor: '#4F6BED',
  },
});
